import { EAiMode } from '../types';
import isCostlyAiDocument from './isCostlyAiDocument.helper';

type TParams = {
  documentHtml: string | undefined;
  isContentSelected: boolean;
};

const defaultAiMode = ({ documentHtml, isContentSelected }: TParams): EAiMode =>
  !isContentSelected && isCostlyAiDocument(documentHtml) ? EAiMode.ADVANCED : EAiMode.STANDARD;

export default defaultAiMode;
